const recentlyViewedStorageKey = 'shago:recently-viewed-products';

const readRecentlyViewedProducts = () => {
  try {
    const products = JSON.parse(window.localStorage.getItem(recentlyViewedStorageKey));
    return Array.isArray(products) ? products.filter((url) => typeof url === 'string') : [];
  } catch {
    return [];
  }
};

const writeRecentlyViewedProducts = (products) => {
  try {
    window.localStorage.setItem(recentlyViewedStorageKey, JSON.stringify(products));
  } catch {
    // Recently viewed products remain optional when browser storage is unavailable.
  }
};

const fetchRecentlyViewedCard = async (productUrl, sectionId) => {
  const url = new URL(productUrl, window.location.origin);
  url.searchParams.set('section_id', sectionId);

  const response = await fetch(url, { headers: { Accept: 'text/html' } });
  if (!response.ok) throw new Error();

  const html = document.createElement('div');
  html.innerHTML = await response.text();
  return html.querySelector('[data-recently-viewed-card]')?.innerHTML.trim() || '';
};

const initializeRecentlyViewedProducts = (scope = document) => {
  scope
    .querySelectorAll('[data-recently-viewed-products]:not([data-recently-viewed-initialized])')
    .forEach(async (container) => {
      container.dataset.recentlyViewedInitialized = 'true';

      const currentProductUrl = container.dataset.currentProductUrl;
      const sectionId = container.dataset.sectionId;
      const maximumProducts = Number(container.dataset.productsToShow) || 8;
      const list = container.querySelector('[data-recently-viewed-list]');
      const content = container.querySelector('[data-recently-viewed-content]');
      if (!currentProductUrl || !sectionId || !list || !content) return;

      const storedProducts = readRecentlyViewedProducts();
      const previousProducts = storedProducts
        .filter((productUrl) => productUrl !== currentProductUrl)
        .slice(0, maximumProducts);

      const cardResults = await Promise.allSettled(
        previousProducts.map((productUrl) => fetchRecentlyViewedCard(productUrl, sectionId))
      );

      cardResults.forEach((result) => {
        if (result.status !== 'fulfilled' || !result.value) return;
        const item = document.createElement('li');
        item.className = 'related-products__item';
        item.innerHTML = result.value;
        list.append(item);
      });

      if (list.children.length > 0) content.hidden = false;

      writeRecentlyViewedProducts(
        [currentProductUrl, ...storedProducts.filter((productUrl) => productUrl !== currentProductUrl)].slice(0, 20)
      );
    });
};

initializeRecentlyViewedProducts();

document.addEventListener('shopify:section:load', (event) => {
  initializeRecentlyViewedProducts(event.target);
});
